import { Image, Text, VStack } from "@chakra-ui/react";
import ImageLoaderHandler from "@raiden/library/components/ImageLoaderHandler";

/**
 * @typedef {object} Props
 * @property {string} title
 * @property {string} [src]
 * @property {import("react").ReactNode} [description]
 * @property {React.ReactNode} [addon]
 */
/**
 * @param {Props} props
 */
export function Splash({ title, src, description, addon }) {
  return (
    <VStack spacing="1rem">
      {src && (
        <ImageLoaderHandler src={src}>
          {({ ref, src, isLoaded, handleLoad }) => (
            <Image
              ref={ref}
              src={src}
              opacity={isLoaded ? 1 : 0}
              onLoad={handleLoad}
              transition="opacity .25s ease"
              alt=""
            />
          )}
        </ImageLoaderHandler>
      )}

      <Text variant="h3" textAlign="center">
        {title}
      </Text>

      {description && (
        <Text textAlign="center" color="gray.400" whiteSpace="pre-wrap">
          {description}
        </Text>
      )}

      {addon && addon}
    </VStack>
  );
}
